import auth from 'app/auth/store/reducers';
import { combineReducers } from 'redux';
import fuse from './fuse';
import ux from './ux';

const createReducer = (asyncReducers) =>
  combineReducers({
    auth,
    fuse,
    ux,
    ...asyncReducers,
  });

export default createReducer;
